import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=ebdcbd2c&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=ebdcbd2c&prod&lang=scss&"
import style1 from "./Menu.vue?vue&type=style&index=1&id=ebdcbd2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdcbd2c",
  null
  
)

export default component.exports